import { ReactNode } from "react";
import classNames from "classnames";
import { XIcon } from "src/assets/Icons";
import { SeatType } from "src/Modules/Flights/constants/JourneyDetails";
import { compactNumber } from "src/utility";
import SeatUseIcon from "../SeatIcon/SeatUseIcon";

export type SeatVisualState = "available" | "selected" | "unavailable" | "ExitRow";

type SeatVisualConfig = {
  iconClassName: string;
  transform: (seat: SeatType) => ReactNode;
};

export function getSeatVisualState(isAvailable: boolean, isSelected: boolean, isExit:boolean): SeatVisualState {
  if (!isAvailable) return "unavailable";
  if (isSelected) return "selected";
  if (isExit) return "ExitRow";
  return "available";
}

const renderPrice = (seat: SeatType) => (
  <>
    <span className="font-bold text-[clamp(.7rem,.8cqw,1rem)]">{compactNumber(seat.price)}</span>
    <span className="font-normal text-[clamp(.4rem,.7cqw,.8rem)]">{seat.currency}</span>
  </>
);

const renderUnavailable = () => <XIcon className="size-2 md:size-2.5" />;

const createSeatVisual = (iconClassName: string, textClassName: string, renderContent: (seat: SeatType) => ReactNode): SeatVisualConfig => ({
  iconClassName,
  transform: (seat) => (
    <>
      <SeatUseIcon className={classNames("absolute! inset-0! h-full! w-full!", iconClassName)} />
      <span
        className={classNames(
          "font-poppins! relative! z-10! flex! flex-col! items-center! text-xs! font-semibold! text-[clamp(.1rem,.8cqw,1rem)]!",
          textClassName,
        )}
      >
        {renderContent(seat)}
      </span>
    </>
  ),
});

export const SEAT_VISUAL_CONFIG: Record<SeatVisualState, SeatVisualConfig> = {
  available: createSeatVisual("fill-background-primary-light!", "text-font-default!", renderPrice),
  selected: createSeatVisual("fill-background-active!", "text-font-default!", renderPrice),
  unavailable: createSeatVisual("fill-background-disabled! stroke-border-disabled!", "text-font-disabled!", renderUnavailable),
  ExitRow: createSeatVisual("fill-border-warning! stroke-border-warning! stroke-dashed!", "text-font-warning!", renderPrice),
};

export const SEAT_FILL_CLASSNAME = Object.fromEntries(
  Object.entries(SEAT_VISUAL_CONFIG).map(([state, config]) => [state, config.iconClassName]),
) as Record<SeatVisualState, string>;
